module.exports = __webpack_public_path__ + "static/heliocare-spray-ad680c2e7fc6009e070372c1e3420be3.jpg";